import {Injectable} from '@angular/core';
import {DataOBJ, DataObjService, RestService} from './rest-service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class TariffClassService implements DataObjService<TariffClass> {

  restHelper: RestService<TariffClass>;

  readonly apiPath = '/api/call_event/v1/tariff_class';

  constructor(private httpClient: HttpClient) {
    this.restHelper = new RestService<TariffClass>(this.apiPath, httpClient, TariffClass.fromJSON)
  }

  getAll(): Observable<TariffClass[]> {
    return this.restHelper.getAll();
  }

  getAllByCustomerId(customerId: string): Observable<TariffClass[]> {
    return this.restHelper.getAllByCustomerId(customerId);
  }

  getById(id: string): Observable<TariffClass> {
    return this.restHelper.getById(id);
  }

  save(obj: TariffClass): Observable<TariffClass> {
    return this.restHelper.save(obj);
  }

  update(obj: TariffClass): Observable<TariffClass> {
    return this.restHelper.update(obj);
  }

  delete(obj: TariffClass): Observable<string> {
    return this.restHelper.delete(obj);
  }

}

export class TariffClass implements DataOBJ {

  static fromJSON(json: any): TariffClass {
    const object: TariffClass = Object.create(TariffClass.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public id: string, public description: string, public customerId: string, public callClasses: Array<CallClass>,
              public initialTime: number, public incrementTime: number, public initialCost: number, public incrementCost: number,
              public validSince: number, public minimumDuration: number, public ignoreDuration: number, public deleted: boolean) {
  }

  getHumanIdentifier() {
    return this.description;
  }

}

export enum CallClass {
  UNKNOWN ,
  INTERNAL,
  LOCAL,
  LONG_DISTANCE,
  VC1,
  VC2,
  VC3,
  INTERNATIONAL
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/tariff-class.service.ts